import {InputType} from "../condition/inputFields/constants";
import {InputFields} from "../condition/inputFields/userGroupInputFields";
import {ArrayContains, StringIn} from "../condition/model/SimpleCondition";
import {isNullCondition} from "../condition/utils/isNullCondition";
import {
  findRelatedSimpleCoditionInKeyCondition,
  nodeAdditionForKeyCondition,
  nodeDeletionForKeyCondition,
  nodeReplaceForKeyCondition,
} from "../condition/utils/transitions/transitionsForKeyConditions";
import {Operators} from "../condition/model/Operators";

export function keyConditionTransitionsBasedOnInputs(
  keyCondition,
  changedAttributeName,
  changedValue
) {
  let editedKeyCondition=keyCondition
  let node;

  function createSimpleNode() {
    const inputTypeOfAttribute = InputFields[changedAttributeName].inputType;
    if (inputTypeOfAttribute === InputType.MultiValuedFieldInBackend.name) {
      if (!Array.isArray(changedValue)) {
        changedValue = changedValue.split("SPLIT");
      }
      node = ArrayContains.createArrayContainsNode(changedAttributeName, changedValue);
    } else if (inputTypeOfAttribute === InputType.SingleValuedFieldInBackend.name) {
      node = StringIn.createStringInNode(changedAttributeName, changedValue)
    }
  }

  const isUnselectedInput = changedValue === undefined || (Array.isArray(changedValue) && changedValue.length === 0);

  if (isNullCondition(editedKeyCondition) && isUnselectedInput)
    return editedKeyCondition;

  if (isNullCondition(editedKeyCondition)) {
    createSimpleNode();
    return node;
  }

  node = findRelatedSimpleCoditionInKeyCondition(editedKeyCondition, changedAttributeName);

  if (isNullCondition(node) && !isUnselectedInput) {
    createSimpleNode();
    return nodeAdditionForKeyCondition(editedKeyCondition, node);
  } else if (!isNullCondition(node) && isUnselectedInput) {
    return nodeDeletionForKeyCondition(editedKeyCondition, node);
  } else if (!isNullCondition(node)) {
    if(node.operator===Operators.comparisonEQ){
      editedKeyCondition= nodeReplaceForKeyCondition(editedKeyCondition,node,node.toStringIn())
      node= findRelatedSimpleCoditionInKeyCondition(editedKeyCondition, changedAttributeName)
    }
    node.setValue(changedValue);
  }
  return editedKeyCondition;
}
